<div class="detailsimg-panel">
    <ng-content select="[detailimg]"></ng-content>
    <ng-content></ng-content>
</div>